import { createRoot, hydrateRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import { initAnalytics } from "./lib/analytics";

initAnalytics();

const container = document.getElementById("root")!;
const normalise = (p: string) => p.replace(/\/+$/, "") || "/";
const prerenderedPath = container.dataset.prerenderedPath;

if (prerenderedPath && container.hasChildNodes() && normalise(prerenderedPath) === normalise(window.location.pathname)) {
  // Prerendered marketing page: attach React to the existing HTML.
  hydrateRoot(container, <App />, {
    onRecoverableError: (error) => {
      (window as unknown as { __hydrationIssues?: number }).__hydrationIssues =
        ((window as unknown as { __hydrationIssues?: number }).__hydrationIssues ?? 0) + 1;
      if (import.meta.env.DEV) console.warn("[hydrate]", error);
    },
  });
} else {
  // App-only route served via the hosting fallback (or dev): render fresh.
  container.innerHTML = "";
  document.getElementById("spa-fallback-style")?.remove();
  createRoot(container).render(<App />);
}
